import { Injectable } from "@angular/core";
import { MultiEditError } from "@sharedcommon/model/multi-edit-error.model";
import { SharedSortOrder } from "@sharedcommon/model/shared-sort-order.model";


@Injectable()
export class RawMaterialsMultiEditService {
    rawMaterialsId: string[];
    multiEditErrors: MultiEditError[];
    currentSort: SharedSortOrder[];
}